import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { GolfClass, GolfClassesQuery, Member } from 'src/app/libs/proto/commUnity_pb';
import { GrpcGolfClassLibService } from 'src/app/service/grpc/golf_classes/grpc-golfclass-lib.service';
import { GrpcLibService } from 'src/app/service/grpc/grpc-lib.service';
import { UserLibService } from 'src/app/service/user/user-lib.service';


@Component({
  selector: 'app-golf-classs-participants',
  templateUrl: './golf_classs_participants.component.html',
  styleUrls: ['./golf_classs_participants.component.sass']
})
export class GolfClassesParticipantsComponent implements OnInit {

  participants$: Promise<Member[]>;
  T: {k?: string, t?: string} = {};
  classid: string|null = null;
  loading = true;
  class?: GolfClass;

  constructor(
    private route: Router,
    private actRoute: ActivatedRoute,
    private grpcLib: GrpcGolfClassLibService,
    private translate: TranslateService,
    private userLib: UserLibService,
private safeurl: DomSanitizer,
  ) { }
  ngOnInit(): void {
    const thise = this;

    new Promise((resolve, reject) => {
        this.actRoute.paramMap.subscribe({next: (p) => {
          thise.classid = p.get('id');
          resolve(true);
        }, error: reject});
      
    }).finally(() =>  {
        this.translate.get(
          ['']
        ).toPromise().then( t => {
          thise.T = t as {k?: string, t?: string};
        }).finally(async () => {
          let req = new GolfClassesQuery();
          req.setId(thise.classid || '');
          let c = await this.grpcLib.getGolfClasses({
            call: {
              req: req,
            }
          })
          if (c && c.length > 0) {
            thise.class = c[0];
          }

          thise.participants$ = this.grpcLib.getGolfClassAttendees(
              this.classid || ''
          )
          .catch( (e: Error) => {
            if (e.message === GrpcLibService.ERR_SIGIN) {

              thise.userLib.clear();
              thise.route.navigateByUrl('/login');
              return;
            }
            // return to complete
            return of([]).toPromise();
          }).finally(() => {
            this.loading = false;
          })
        });      
    });
  }
  get dateFormat(): string {
    return this.userLib.dateFormat;
  }
  tellink(tel: string) {
    return this.safeurl.bypassSecurityTrustUrl(tel);
  }
}
